import {newAxios} from './index'
const cus = true
export const Req_CreateAccount = function(data) {
  return newAxios({
    url: `/i/tenant/crm/customer/book/account/add`,
    data
  },'json')()
}

export const Req_GetCustomerAccountList = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/finance/list`,
    data
  })()
}

export const Req_GetAccountInfo = function (data) {
  return newAxios({
    url: '/i/tenant/crm/customer/book/account/info',
    data
  })()
}

export const Req_UpdateAccount = function (data) {
  return newAxios({
    url: `/i/tenant/crm/customer/book/account/update`,
    data
  },'json')()
}

export const Req_GetDeleteCode = function (data) {
  return newAxios({
    url: `/i/tenant/basic/delete/book/code`,
    data
  })()
}

export const Req_DeleteAccount = function (data) {
  return newAxios({
    url: `/i/tenant/user/customer/period/delete`,
    data,
    cus
  })()
}

//根据字典类型查找列表
export const Req_GetDicDataList = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/info/management/dictionary`
  })()
}

//根据数据权限获取服务顾问
export const Req_GetCustomerConsultant = function (data) {
  return newAxios({
    url:'/i/tenant/crm/customer/list/consultant'
  })()
}

//获取查账列表数据
export const Req_GetBookDataList = function (data) {
  return newAxios({
    url:'/i/tenant/finance/customer/book/data/page/list',
    data
  },'json')()
}

//保存查账表头设置
export const Req_SetBookDataConfig = function (data) {
  return newAxios({
    url:`/i/tenant/finance/customer/book/data/save`,
    data,
  },'json')()
}

//获取最后更新日期
export const Req_GetLastUpdateDate = function (data) {
  return newAxios({
    url:`/i/tenant/finance/customer/book/data/state`,
    data
  },'',false)()
}

//获取表格头部设置
export const Req_GetHeaderConfig = function (data) {
  return newAxios({
    url:`/i/tenant/finance/customer/book/data/get/config`,
    data
  })()
}

//刷新客户查账数据
export const Req_RefreshBookData = function (data) {
  return newAxios({
    url:`/i/tenant/finance/customer/book/data/refresh`,
    data
  },'json')()
}


//检查客户必填信息是否完善
export const Req_CheckAccountRequired = function (data) {
  return newAxios({
    url:`/i/tenant/crm/customer/required/info/check`,
    data
  })()
}


export const Req_AddWarningLog = data => {
  return newAxios({
    url: `/i/tenant/system/sys/warning/log/add`,
    data
  },'json')()
}

export const Req_SmallScaleBatchExport = data => {
  return newAxios({
    url: '/i/tenant/finance/book/export/excel',
    data
  })()
}

export const Req_ExportCusAnalysisReport = data => {
  return newAxios({
    url: `/i/tenant/finance/customer/book/data/analyze/export`,
    data
  },'json')()
}

export const Req_GetTaxGovSendCodes = () => {
  return newAxios({
    url: `/i/tenant/basic/task/code/page`,
    data: {
      pageNum:1,
      pageSize: 99
    }
  })()
}


// WEBPACK FOOTER //
// ./src/request/account.js